export default ".mdc-text-field {\n  width: 100%;\n}"